export default defineNuxtRouteMiddleware((to) => {
	if (to.name === "order") {
		abortNavigation();

		return navigateTo("/order/cart");
	}
}
);
